module.exports = "../study/imgs/maps/Nagano/S8/Agriculture/Rice/Nagano_Rice_GFDL_RCP26_Now.png";